<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click="backdropClose">
      <div class="modal" :class="variant" @click.stop>
        <slot>
          <header class="modal-header">
            <slot name="header"></slot>
          </header>
          <section class="modal-body">
            <slot name="body"></slot>
           </section>
           <footer class="modal-footer">
              <slot name="footer"></slot>
          </footer>
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
  import Button from '@/components/Button.vue';

  export default {
    name: 'Modal',
    components: {
        'v-button': Button,
    },
    props: {
      variant: { type: String, default: null },
      backdrop: { type: Boolean, default: true }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      backdropClose() {
        if (this.backdrop) {
          this.close();
        }
      }
    },
  };
</script>

<style>
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .25s ease
  }

  .modal-backdrop {
    position: fixed;
    z-index: 1000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin-right: var(--rightbar-width-xl);
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(130,130,130,.5);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    max-width: 480px;
  }
  .modal.error {
    background-color: #FFFFFF;
    max-width: 420px
  }
  .modal.medium { max-width: 640px }
  .modal.large {
    max-width: 800px;
    width: 100%;
  }
  .modal.video,
  .modal.media {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: none;
    background-color: #000;
    color: var(--white);
    box-shadow: 0 4px 8px 0 rgba(0,0,0,.5);
  }
  .fullscreen .modal.video {
    bottom: 0;
  }
  .modal.media {
    bottom: 0;
    background-color: transparent;
    box-shadow: none;
    margin-right: var(--rightbar-width-xl);
  }

  .modal-header,
  .modal-footer {
    padding: var(--space-3);
    display: flex;
  }

  .modal-header {
    justify-content: center;
    font-weight: 600;
  }

  .modal-footer {
    justify-content: center;
  }

  .modal-body {
    position: relative;
    padding-left: var(--space-3);
    padding-right: var(--space-3);
    font-size: var(--h5);
    text-align: center;
  }

  .media-container video,
  .media-container img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  /* Fixed aspect ratio of 16:9 */
  .media-container {
    position: relative;
    padding-bottom: 56.25%;
    overflow: hidden;
  }

  /* No aspect ratio on full screen modal */
  .fullscreen .media-container {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  @media (--breakpoint-lg) {
    .modal.video {
      left: var(--sidebar-width);
      right: var(--rightbar-width);
    }

    .fullscreen .modal.video {
      left: 0;
      right: 0;
    }
  }

  @media (--breakpoint-xl) {
    .modal.video {
      left: var(--sidebar-width-xl);
      right: var(--rightbar-width-xl);
    }

    .fullscreen .modal.video {
      left: 0;
      right: 0;
    }
  }

  @custom-media --breakpoint-lg (min-width: 64em);
  @custom-media --breakpoint-xl (min-width: 80em);
</style>
